import {createSlice} from '@reduxjs/toolkit'

const imageSlice = createSlice({
    name: 'image',
    initialState: {
        originalImage: {
            url: null,
            black: 0,
            percentage: 0,
            width: null,
            height: null,
        },
        currentImage: {
            url: null,
            black: 0,
            percentage: 0,
            width: null,
            height: null,
        },
        file: null,
        redURL: undefined,
        originalURL: undefined,
        currentURL: undefined,
        blackURL: undefined,
        width: 0,
        height: 0,
        manipulating: false,
        thresholds: {
            red: 0,
            green: 0,
            blue: 0,
        },
        black: 0,
        originalBlack: 0,
        percentage: 0,
        originalPercentage: 0,
        statsLoading: false,
        blackLoading: false,
        statsSet: false,
        isRed: false,
        lastEdited: new Date().toISOString(),
    },
    reducers: {
        // TODO: Set original stats ?? (maybe already done)
        setFile: (state, action) => { state.file = action.payload },
        toggleIsRed: (state, action) => { state.isRed = !state.isRed },
        firstBlackRead: (state, action) => {
            state.black = action.payload.black;
            state.black = action.payload.black;
        },
        resetImageSuccess: (state, action) => {
            state.currentURL = state.originalURL;
            state.blackURL = state.originalURL;
            state.redURL = undefined;
            state.black = state.originalBlack;
            state.percentage = state.originalPercentage;
            state.thresholds = {
                red: 0,
                green: 0,
                blue: 0,
            };
        },
        setOriginalImage: (state, action) => {
            state.originalURL = action.payload;
            state.currentURL = action.payload;
            state.blackURL = action.payload;
            state.redURL = undefined;
            state.black = state.originalBlack;
            state.percentage = state.originalPercentage;
            state.lastEdited = new Date().toISOString();
            state.thresholds = {
                red: 0,
                green: 0,
                blue: 0,
            };
        },
        setThresholdsSuccess: (state, action) => {
            state.thresholds = action.payload;
        },
        setRedSuccess: (state, action) => {
            state.thresholds.red = action.payload;
            if (state.locked) {
                state.thresholds.green = action.payload;
                state.thresholds.blue = action.payload;
            }
        },
        setGreenSuccess: (state, action) => {
            state.thresholds.green = action.payload;
            if (state.locked) {
                state.thresholds.red = action.payload;
                state.thresholds.blue = action.payload;
            }
        },
        setBlueSuccess: (state, action) => {
            state.thresholds.blue = action.payload;
            if (state.locked) {
                state.thresholds.green = action.payload;
                state.thresholds.red = action.payload;
            }
        },
        resetThresholdsSuccess: (state, action) => {
            state.thresholds.red = 0;
            state.thresholds.green = 0;
            state.thresholds.blue = 0;
        },
        setDimensionsSuccess: (state, action) => {
            state.width = action.payload.width;
            state.height = action.payload.height;
        },
        setBlackSuccess: (state, action) => {
            state.black = action.payload;
            state.percentage = action.payload / (state.width * state.height) * 100;
            state.blackLoading = false;
        },
        setImageStatsSuccess: (state, action) => {
            state.black = action.payload.black;
            state.width = action.payload.width;
            state.height = action.payload.height;
            state.percentage = action.payload.black / (action.payload.width * action.payload.height) * 100;
            state.statsLoading = false;
            state.statsSet = true;
        },
        setStatsLoadingSuccess: (state, action) => {
            state.statsLoading = action.payload;
        },
        setStatsSetSuccess: (state, action) => {
            state.statsSet = action.payload;
        },
        clearImageSuccess: (state, action) => {
            state.black = 0
            state.percent = 0;
            state.width = 0;
            state.height = 0;
            state.statsSet = false;
        },
        setManipulatingSuccess: (state, action) => {
            state.manipulating = action.payload;
        },
        setImageSuccess: (state, action) => {
            state.currentURL = action.payload;
            state.manipulating = false;
            state.lastEdited = new Date().toISOString();
        },
        setIsRedSuccess: (state, action) => {
            state.isRed = action.payload;
        },
        setRedURLSuccess: (state, action) => {
            state.redURL = action.payload;
        },
        setBlackURLSuccess: (state, action) => {
            state.blackURL = action.payload;
        },
        setOriginalStatsSuccess: (state, action) => {
            state.originalBlack = action.payload.black;
            state.originalPercentage = action.payload.black / (action.payload.width * action.payload.height) * 100;
        },
    },
})


export const setBlack = (value) => async (dispatch) => dispatch(setBlackSuccess(value))
export const setBlackURL = (url) => async (dispatch) => dispatch(setBlackURLSuccess(url))
export const setDimensions = (width, height) => async (dispatch) => dispatch(setDimensionsSuccess({width: width, height: height}))
export const setImage = (value) => async (dispatch) => dispatch(setImageSuccess(value))
export const setImageStats = (values) => async (dispatch) => dispatch(setImageStatsSuccess(values))
export const setManipulating = (value) => async (dispatch) => dispatch(setManipulatingSuccess(value))
export const setRedURL = (url) => async (dispatch) => dispatch(setRedURLSuccess(url))
export const setStatsLoading = (value) => async (dispatch) => dispatch(setStatsLoadingSuccess(value))
export const setStatsSet = (value) => async (dispatch) => dispatch(setStatsSetSuccess(value))
export const setThresholds = (values) => async (dispatch) => dispatch(setThresholdsSuccess(values))
export const clearImage = () => async (dispatch) => dispatch(clearImageSuccess())
export const resetImage = () => async (dispatch) => dispatch(resetImageSuccess())
export const resetThresholds = () => async (dispatch) => dispatch(resetThresholdsSuccess())
export const toggleRed = () => async (dispatch, getState) => dispatch(setIsRedSuccess(!getState().image.isRed))
export const setIsRed = (value) => async (dispatch) => dispatch(setIsRedSuccess(value))
export const setOriginalStats = (value) => async (dispatch) => dispatch(setOriginalStatsSuccess(value))

export const setRed = (value) => async (dispatch, getState) => {
    if (getState().app.slidersLocked)
        dispatch(setThresholdsSuccess({red: value, green: value, blue: value}))
    else
        dispatch(setRedSuccess(value))
}

export const setGreen = (value) => async (dispatch, getState) => {
    if (getState().app.slidersLocked)
        dispatch(setThresholdsSuccess({red: value, green: value, blue: value}))
    else
        dispatch(setGreenSuccess(value))
}

export const setBlue = (value) => async (dispatch, getState) => {
    if (getState().app.slidersLocked)
        dispatch(setThresholdsSuccess({red: value, green: value, blue: value}))
    else
        dispatch(setBlueSuccess(value))
}


export const {
    setThresholdsSuccess,
    clearImageSuccess,
    setRedSuccess,
    setGreenSuccess,
    setBlueSuccess,
    setDimensionsSuccess,
    setBlackSuccess,
    setStatsLoadingSuccess,
    setStatsSetSuccess,
    setImageStatsSuccess,
    setOriginalImage,
    resetImageSuccess,
    setManipulatingSuccess,
    setImageSuccess,
    setIsRedSuccess,
    resetThresholdsSuccess,
    setRedURLSuccess,
    setBlackURLSuccess,
    setLockedSuccess,
    setOriginalStatsSuccess,
    toggleIsRed,
    setFile,
} = imageSlice.actions

export default imageSlice.reducer
